export default __webpack_public_path__ + "static/media/barra.3c621bcc.png";